import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Typography, Icon } from "@ann/web-components";
import { HeaderContainer, TitleContainer, IconWrapper } from "./Header.styled";

const Header = ({ title }) => {
  const navigate = useNavigate();
  const { knowledgeId } = useParams();

  const handleBackClick = () => {
    navigate(`/v2/knowledge/knowledge-hub/${knowledgeId}/facts`);
  };

  return (
    <HeaderContainer>
      <TitleContainer>
        <IconWrapper onClick={handleBackClick}>
          <Icon name="arrowLeft" size="medium" />
        </IconWrapper>
        {title && (
          <Typography Typography category="title" size="large" weight="bold">
            {title}
          </Typography>
        )}
      </TitleContainer>
    </HeaderContainer>
  );
};

export default Header;

